<template>
  <div>
    <v-card
      style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
    >
      <v-flex class="pb-2 pt-0" xs8>
        <div v-if="loading" class="px-3 mt-2 py-2">
          <v-progress-linear
            :indeterminate="true"
            color="success"
          ></v-progress-linear>
        </div>
        <v-form ref="form">
          <v-layout row justify-space-between>
            <v-layout column class="ma-1 px-3">
              <v-card-text
                class="mb-0 pb-0 pt-2 pl-2 mt-3"
                v-if="request && request.id"
              >
                <v-layout row align-center>
                  <v-flex xs12>
                    <div class="ml-3 mt-2 body-1 font-weight-light">
                      <v-layout row>
                        <v-flex xs6>
                          <v-layout row align-center>
                            <div
                              class="font-weight-medium mr-3"
                              style="min-width: 80px;"
                            >
                              Technician:
                            </div>
                            <v-autocomplete
                              class="py-0"
                              id="technician"
                              @click="
                                (e) => {
                                  !technicianTouchet ? handleTouch(e) : '';
                                }
                              "
                              v-model="editForm.technician"
                              :items="
                                !technicianTouchet
                                  ? [request.technicianName]
                                  : technicians.map((t) => t.name)
                              "
                              placeholder="Select Technician"
                              dense
                              clearable
                              style="max-width: 200px;"
                            ></v-autocomplete>
                          </v-layout>
                          <v-layout row align-center>
                            <div
                              class="font-weight-medium mr-3"
                              style="min-width: 80px;"
                            >
                              Category:
                            </div>
                            <v-autocomplete
                              @click="
                                (e) => {
                                  !categoryTouchet ? handleTouch(e) : '';
                                }
                              "
                              id="category"
                              class="py-0"
                              v-model="editForm.category"
                              :items="
                                !categoryTouchet
                                  ? [request.categoryName]
                                  : categorys
                              "
                              placeholder="Select Category"
                              dense
                              style="max-width: 200px;"
                              :rules="[rules.required]"
                            ></v-autocomplete>
                          </v-layout>
                          <v-layout row align-center>
                            <div
                              class="font-weight-medium mr-3"
                              style="min-width: 80px;"
                            >
                              Priority:
                            </div>
                            <v-select
                              class="py-0"
                              v-model="editForm.priority"
                              :items="priorityOptions"
                              item-text="text"
                              item-value="value"
                              dense
                              style="max-width: 200px;"
                              :rules="[rules.required]"
                            >
                              <template v-slot:item="{ item }">
                                <v-icon small :color="item.color" class="mr-2"
                                  >mdi-box-shadow</v-icon
                                >
                                <span>{{ item.text }}</span>
                              </template>
                              <template v-slot:selection="{ item }">
                                <v-icon small :color="item.color" class="mr-2"
                                  >mdi-box-shadow</v-icon
                                >
                                <span>{{ item.text }}</span>
                              </template>
                            </v-select>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6>
                          <!-- <v-layout row align-center class="mb-3">
                          <div
                            class="font-weight-medium mr-2"
                            style="min-width: 80px;"
                          >
                            Status:
                          </div>
                          <v-autocomplete
                            class="py-0"
                            v-model="editForm.status"
                            :items="status"
                            placeholder="Select Status"
                            dense
                            style="max-width: 200px;"
                          ></v-autocomplete>
                        </v-layout> -->
                          <v-layout row align-center>
                            <div
                              class="font-weight-medium mr-3"
                              style="min-width: 80px;"
                            >
                              Site:
                            </div>
                            <v-autocomplete
                              @click="
                                (e) => {
                                  !siteTouchet ? handleTouch(e) : '';
                                }
                              "
                              id="site"
                              class="py-0"
                              v-model="editForm.site"
                              :items="
                                !siteTouchet
                                  ? [request.requestSiteName]
                                  : sites.map((t) => t.name)
                              "
                              placeholder="Select Site"
                              dense
                              style="max-width: 200px;"
                            ></v-autocomplete>
                          </v-layout>
                          <v-layout row align-center class="mb-3">
                            <div
                              class="font-weight-medium mr-2"
                              style="min-width: 80px;"
                            >
                              Due Date:
                            </div>
                            <input
                              type="date"
                              v-model="editForm.dueDate"
                              :disabled="editForm.dueDateValueNow"
                              style="
                                  padding: 8px;
                                  border: 1px solid #ccc;
                                  border-radius: 4px;
                                  width: 100%;
                                  max-width: 130px;
                                "
                              :style="
                                editForm.dueDateValueNow
                                  ? 'background-color: #f5f5f5; cursor: not-allowed;'
                                  : ''
                              "
                            />
                            <div class="d-flex flex-column align-center ml-2">
                              <label for="dueDateValueNow" class="caption"
                                >Due Now</label
                              >
                              <v-checkbox
                                v-model="editForm.dueDateValueNow"
                                ref="dueDateValueNow"
                                id="dueDateValueNow"
                                color="primary"
                                hide-details
                                class="mt-0 pt-0"
                              ></v-checkbox>
                            </div>
                          </v-layout>
                          <!-- <v-layout row align-center>
                            <div
                              class="font-weight-medium mr-2"
                              style="min-width: 80px;"
                            >
                              Time:
                            </div>
                            <input
                              type="time"
                              v-model="editForm.dueTime"
                              style="
                                  padding: 8px;
                                  border: 1px solid #ccc;
                                  border-radius: 4px;
                                  width: 100%;
                                  max-width: 200px;
                                "
                            />
                          </v-layout> -->
                        </v-flex>
                        <v-flex xs6>
                          <v-layout row align-center>
                            <v-flex
                              style="display: flex; align-items: center; justify-content: center; width: 100%;"
                            >
                              <v-icon
                                v-if="!saving"
                                large
                                left
                                color="green"
                                @click="saveTicket"
                                >mdi-check-circle-outline</v-icon
                              >
                              <v-icon
                                v-else
                                class="mdi-spin"
                                large
                                left
                                color="green"
                                >mdi-loading</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row align-center>
                  <v-flex xs12>
                    <div class="mt-0 ml-3 mb-2 body-1 font-weight-light">
                      <v-layout row align-center>
                        <div
                          class="font-weight-medium mr-3"
                          style="min-width: 80px;"
                        >
                          Subject:
                        </div>
                        <v-text-field
                          class="py-0"
                          v-model="editForm.subject"
                          placeholder="Enter a brief title for your request"
                          dense
                          style="max-width: 65%;"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-layout>
                      <v-layout row align-baseline>
                        <div
                          class="font-weight-medium mr-3"
                          style="max-width: 80%;"
                        >
                          Description:
                        </div>
                        <div
                          v-html="request.description"
                          @input="updateDescription"
                          contenteditable="true"
                          label="Description"
                          rows="5"
                          class="mt-2"
                          outline
                          style="width: 70%; min-height: 120px; padding: 10px; border: 2px solid #ccc; border-radius: 4px;"
                        ></div>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-layout>
          </v-layout>
          <v-spacer></v-spacer>
          <div v-if="request && request.id">
            <v-flex
              style="display: flex; align-items: center; justify-content: center; width: 100%;"
            >
              <v-btn color="default" class="mr-3 mb-2" @click="cancel" dark
                >Cancel</v-btn
              >
              <v-btn
                color="success"
                class="mr-3 mb-2"
                :loading="saving"
                @click="saveTicket"
              >
                Save Changes
              </v-btn>
            </v-flex>
          </div>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import CloseTicketDialog from "./CloseTicketDialog.vue";
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CloseTicketDialog,
  },
  data: () => ({
    loading: true,
    request: null,
    requester: null,
    SearchUserTickets: false,
    processing: false,
    closeTicketDialog: false,
    addNoteDialog: false,
    addNoteDescription: "",
    saving: false,
    technicians: [],
    categorys: [],
    sites: [],
    status: ["Open", "On Hold", "Closed"],
    siteTouchet: false,
    technicianTouchet: false,
    categoryTouchet: false,
    editForm: {
      technician: "",
      category: "",
      priority: "",
      status: "",
      subject: "",
      description: "",
      dueDate: "",
      dueTime: "",
      dueDateValueNow: false,
      site: "",
    },
    priorityOptions: [
      { text: "High", value: "1 High", color: "#e74c3c" },
      { text: "Normal", value: "2 Normal", color: "#f39c12" },
      { text: "Low", value: "4 Low", color: "#7f8c8d" },
    ],
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),

  computed: {},

  watch: {
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.load();
      },
    },
  },

  created() {
    this.load();
  },
  methods: {
    searchUserTickets() {
      this.SearchUserTickets = true;
    },
    async load() {
      this.request = this.initialData;
      this.loading = false;
      this.initializeEditForm();
    },
    initializeEditForm() {
      if (!this.request) return;

      // Initialize technician
      this.editForm.technician = this.request.technicianName
        ? this.request.technicianName
        : "";

      // Initialize category
      this.editForm.category = this.request.categoryName || "";

      // Initialize priority
      const priorityMap = {
        "1 High": "1 High",
        "3 Option 8": "1 High",
        "2 Normal": "2 Normal",
        "4 Low": "4 Low",
      };
      this.editForm.priority =
        priorityMap[this.request.priorityName] || "2 Normal";

      // Initialize status
      this.editForm.status = this.request.statusName || "Open";

      // Initialize subject
      this.editForm.subject = this.request.subject || "";

      // Initialize description - strip HTML tags for editing
      //   if (this.request.description) {
      //        const tempDiv = document.createElement("div");
      //       tempDiv.innerHTML = this.request.description;
      //       tempDiv.textContent || tempDiv.innerText || "";
      //   } else {
      //     this.editForm.description = "";
      //   }
      this.editForm.description = this.request.description || "";
      // Initialize Due Date
      if (this.request.dueByTimeValue) {
        try {
          const dueDate = new Date(Number(this.request.dueByTimeValue));
          const localDateString = new Date(
            dueDate.getTime() - dueDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 10);

          this.editForm.dueDate = localDateString;

          const hours = String(dueDate.getHours()).padStart(2, "0");
          const minutes = String(dueDate.getMinutes()).padStart(2, "0");
          this.editForm.dueTime = `${hours}:${minutes}`;
        } catch (e) {
          this.editForm.dueDate = "";
          this.editForm.dueTime = "";
        }
      } else {
        this.editForm.dueDate = "";
        this.editForm.dueTime = "";
      }

      this.editForm.site = this.request.requestSiteName
        ? this.request.requestSiteName
        : "";
    },
    async getTechnicians() {
      try {
        const response = await this.$http.get(
          "api/manageengine/getTechnicians"
        );
        this.technicians = response.technician.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async getCategorys() {
      try {
        const response = await this.$http.get("api/manageengine/getCategorys");
        this.categorys = response.category.map((m) => m.name);
      } catch (error) {
        console.error(error);
      }
    },
    async getSites() {
      try {
        const response = await this.$http.get("api/manageengine/getSites");
        this.sites = response.site.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async saveTicket() {
      if (!this.$refs.form.validate(true)) {
        return;
      }
      try {
        this.saving = true;

        const technician = this.technicians.find(
          (t) => t.name === this.editForm.technician
        );
        const technicianId = technician ? technician.id : "clear";

        const site = this.sites.find((t) => t.name === this.editForm.site);
        const siteId = site ? site.id : null;
        var dueDateTimestamp = null;

        const dueDateChanged =
          (this.request.dueByAt &&
            this.request.dueByAt.slice(0, 10) != this.editForm.dueDate) ||
          this.editForm.dueDateValueNow ||
          (!this.request.dueByAt && this.editForm.dueDate);

        if (
          dueDateChanged &&
          this.editForm.dueDate &&
          !this.editForm.dueDateValueNow
        ) {
          const dueDateTime = new Date(`${this.editForm.dueDate}T23:00`);
          dueDateTimestamp = dueDateTime.getTime();
        } else if (dueDateChanged && this.editForm.dueDateValueNow) {
          dueDateTimestamp = new Date().getTime() + 60000;
        }
        if (
          dueDateTimestamp &&
          dueDateTimestamp < this.request.createdTimeValue
        ) {
          return this.$notify({
            group: "notification",
            text:
              "Set valid due by date. Due by date cannot be a prior date to created date.",
            type: "error",
          });
        }

        const subject = this.editForm.subject
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");

        const payload = {};

        if (
          (this.editForm.technician || this.request.technicianName) &&
          this.editForm.technician != this.request.technicianName
        ) {
          payload.TechnicianId = technicianId;
        }
        if (this.editForm.category != this.request.categoryName) {
          payload.CategoryName = this.editForm.category;
        }
        if (this.editForm.priority != this.request.priorityName) {
          payload.PriorityName = this.editForm.priority;
        }
        if (dueDateChanged) {
          payload.DueDateValue = dueDateTimestamp;
        }
        if (subject != this.request.subject) {
          payload.Subject = subject;
        }
        if (this.editForm.description != this.request.description) {
          payload.Description = this.editForm.description;
        }
        if (this.editForm.site != this.request.requestSiteName) {
          payload.SiteId = siteId;
        }

        if (Object.keys(payload).length === 0) {
          return this.$notify({
            group: "notification",
            text: "No changes detected",
            type: "info",
          });
        }
        payload.ManageengineID = this.request.manageengineID;
        await this.$http.put(`api/manageengine/editTicket`, payload);
        await this.$emit("updated");
        if (true) {
          this.$notify({
            group: "notification",
            text: `Ticket updated successfully.`,
            type: "success",
          });
        }
      } catch (e) {
        console.error("Error saving ticket:", e);
        this.$notify({
          group: "notification",
          text: "Error updating ticket. Please check console for details.",
          type: "error",
        });
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    updateDescription(v) {
      this.editForm.description = v.target.innerHTML;
    },
    handleTouch(e) {
      if (e.target.id == "site") {
        this.siteTouchet = true;
        this.getSites();
      } else if (e.target.id == "technician") {
        this.technicianTouchet = true;
        this.getTechnicians();
      } else if (e.target.id == "category") {
        this.categoryTouchet = true;
        this.getCategorys();
      }
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}

.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}

.tip-grid.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}

.tip-grid .v-card__text {
  padding-top: 4px !important;
}

.tip-grid .flex {
  padding: 0px !important;
  padding-top: 24px !important;
}

.tip-grid .v-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}

.card-header {
  padding: 5px 0;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.ticket-card {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.button-attachment {
  max-width: 100%;
  display: block;
  margin-top: 8px;
  text-overflow: ellipsis;
}

.ticket-card audio {
  max-width: 100%;
  display: block;
  margin-top: 8px;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.status-text:hover {
  opacity: 0.7;
}
</style>
